<!-- reset-password.component.html -->
<div [hidden]="!invalid">
  <p>Invalid or expired link.</p>
</div>

<div [hidden]="invalid || confirmed">
  <h2>Set a New Password</h2>

  <form
    [formGroup]="updatePassForm"
    (ngSubmit)="updatePassword()">
    <div class="mb-3">
      <label for="reset-pass" class="form-label">New password</label>
      <input type="password" class="form-control" id="reset-pass" formControlName="password">
    </div>
    <div class="d-flex flex-column justify-content-end align-items-center">
      <button type="submit" class="btn btn-secondary rounded w-100" >Update password</button>
    </div>
  </form>

<!--  <input [(ngModel)]="newPassword" type="password" placeholder="New Password" />-->
<!--  <button (click)="updatePassword()">Submit</button>-->
</div>

<div [hidden]="!confirmed">
  <p>Your password has been updated. You may now log in.</p>
</div>
